
const ROLES = Object.freeze({
    OWNER: 'owner',
    MANAGER: 'manager',
    SENIOR_MANAGER: 'seniormanager',
    ADMIN: 'admin',
});

export default ROLES;
